module.exports = __webpack_public_path__ + "img/login_img-min.cde0aa7.png";